import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Header from '../components/header'
import FeatureCard from '../components/feature-card'
import Timeline3 from '../components/timeline3'
import Features19 from '../components/features19'
import Features191 from '../components/features191'
import Pricing14 from '../components/pricing14'
import FooterGray from '../components/footer-gray'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Better Call AI</title>
        <meta
          name="description"
          content="La solution de gestion des appels client par l'intelligence artificielle.\nPrise en charge de votre agenda et prise de rendez-vous automatique."
        />
        <meta property="og:title" content="Better Call AI" />
        <meta
          property="og:description"
          content="La solution de gestion des appels client par l'intelligence artificielle.\nPrise en charge de votre agenda et prise de rendez-vous automatique."
        />
      </Helmet>
      <Header></Header>
      <div className="home-hero">
        <div className="home-container2">
          <div className="home-card">
            <h1 className="home-text10 HeadingOne">La meilleure façon </h1>
            <h1 className="home-text11 HeadingOne">
              de répondre à vos clients
            </h1>
            <span className="home-text12">
              Votre télésecrétariat téléphonique sur-mesure, disponible et
              adapté à votre métier.
            </span>
            <div className="home-container3">
              <div className="home-container4">
                <div className="home-container5">
                  <Script
                    html={`  <a href="tel:+33159241506" 
     style="display: inline-block;padding: 15px 30px; font-size: 16px; color: #fff; background: linear-gradient(310deg,#7928ca,#ff0080); text-decoration: none; border-radius: 30px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); transition: background-color 0.3s, box-shadow 0.3s">
  <div style="font-family: 'Open Sans Condensed', sans-serif; font-weight: 700;"
  >Appeler l'IA 📞 </div>   
  
  </a>
  `}
                  ></Script>
                </div>
              </div>
            </div>
            <div className="home-container6">
              <b className="home-text13 phonev">Ecouter la demo </b>
              <div className="home-container7">
                <div className="home-container8">
                  <Script
                    html={`<figure>
  <audio controls style="width: 100%; border-radius: 5px;" src="https://s3.eu-central-1.amazonaws.com/callai.fr/callbot.mp3">
<div> 
  <button onclick="document.getElementById('player').play()">Play</button> 
  <button onclick="document.getElementById('player').pause()">Pause</button> 
  <button onclick="document.getElementById('player').volume += 0.1">Vol +</button> 
  <button onclick="document.getElementById('player').volume -= 0.1">Vol -</button> 
  


</div>    Votre navigateur ne supporte pas la balise audio.
  </audio>
</figure>`}
                  ></Script>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="Product" className="home-intro">
        <h1 className="home-text14 HeadingOne">Un Télésecrétariat Dédié</h1>
        <p className="home-text15 HeadingThree">
          L&apos;intelligence artificielle au service de votre business. Nos
          moteurs d&apos;IA sont adaptables et personnalisables à souhait. La
          qualification et la gestion de vos appels entrants enfin simplifiée,
          sans prise de tête.
        </p>
        <section className="home-features1">
          <FeatureCard
            text="Nos moteurs d'IA vous permettent de donner des consignes précises sur la façon de traiter les appels entrants"
            title="Components"
            newProp="ULTRA Personnalisable"
            imageSrc="/cube1.svg"
          ></FeatureCard>
          <FeatureCard
            text="Votre téléscrétaire virtuel est capable de se connecter à votre agenda professionnel. Pour un prise de rendez-vous automatisée"
            newProp="ULTRA connecté"
            imageSrc="/person1.svg"
          ></FeatureCard>
          <FeatureCard
            text="Une présence 24/7, prise d'appels en simultané, pas de délai d'attente pour vos clients. Vos appels entrants traités automatiquement."
            title="Less Code"
            newProp="ULTRA disponible"
            imageSrc="/rocket1.svg"
          ></FeatureCard>
        </section>
      </div>
      <img alt="image" src="/curved6-1500h.jpg" className="home-image" />
      <div className="home-integration-steps">
        <Timeline3
          heading={
            <Fragment>
              <span className="home-text16">
                Une intégration Simple, Rapide, efficace
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="home-text17">
                Bénéficiez d&apos;un accompagnement de bout en bout dans le
                déploiement de votre solution de télésecrétariat basé sur
                l&apos;intelligence artificielle.
              </span>
            </Fragment>
          }
          card1Date={
            <Fragment>
              <span className="home-text18">Vos exigences</span>
            </Fragment>
          }
          card1Date1={
            <Fragment>
              <span className="home-text19">Tests</span>
            </Fragment>
          }
          card1Date2={
            <Fragment>
              <span className="home-text20">Production</span>
            </Fragment>
          }
          card1Date3={
            <Fragment>
              <span className="home-text21">Déploiement</span>
            </Fragment>
          }
          card1Content={
            <Fragment>
              <span className="home-text22">
                Nous organisons un rendez-vous afin de récolter votre besoin,
                nous vous orientons vers l&apos;offre la plus adaptée.
              </span>
            </Fragment>
          }
          card2Content={
            <Fragment>
              <span className="home-text23">
                Nous déployons votre agenda et la ligne téléphonique.
              </span>
            </Fragment>
          }
          card3Content={
            <Fragment>
              <span className="home-text24">
                Vous bénéficiez d&apos;une phase de test de 2 semaines durant
                laquelle nous vous permettons d&apos;ajuster les consignes
                fournies au moteur d&apos;IA.
              </span>
            </Fragment>
          }
          card5Content={
            <Fragment>
              <span className="home-text25">
                Vos clients profitent d&apos;un experience de prise de
                rendez-vous inédite.
              </span>
            </Fragment>
          }
        ></Timeline3>
      </div>
      <div id="UC" className="home-features2">
        <Features19
          feature1Title={
            <Fragment>
              <span className="home-text26">
                Avocats, juristes, médecins, vétérinaires, comptables, passez à
                la prise de rendez-vous automatique
              </span>
            </Fragment>
          }
          feature1Slogan={
            <Fragment>
              <span className="home-text27">PROFESSIONS LIBERALES</span>
            </Fragment>
          }
          feature1Action2={
            <Fragment>
              <span className="home-text28">Commencer</span>
            </Fragment>
          }
          feature1ImageSrc="/avocat-500w.webp"
          feature1Description={
            <Fragment>
              <span className="home-text29">
                Que vous soyez avocat, comptable, médecin ou vétérinaire, vous
                avez une mission essentielle dans la société : apporter votre
                expertise et votre savoir-faire pour aider vos clients à
                résoudre leurs problèmes. Cependant, être constamment interrompu
                par le téléphone peut compromettre votre capacité à fournir un
                service de qualité. Chez Better call AI nous savons à quel point
                maintenir un télésecrétariat formé et disponible est difficile
                voire mission impossible. C&apos;est pourquoi nous vous mettons
                à disposition un infinité de possibilités à travers l&apos;IA
              </span>
            </Fragment>
          }
        ></Features19>
      </div>
      <div className="home-features3">
        <Features191
          feature1Title={
            <Fragment>
              <span className="home-text30">
                <span>Coiffeurs, Garagistes, Foodtrucks, mais pas que !</span>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          rootClassName="features191root-class-name"
          feature1Slogan={
            <Fragment>
              <span className="home-text34">PME</span>
            </Fragment>
          }
          feature1Action2={
            <Fragment>
              <span className="home-text35">Commencer</span>
            </Fragment>
          }
          feature1Description={
            <Fragment>
              <span className="home-text36">
                <span>
                  Que vous soyez coiffeur, garagiste, boulanger ou même que vous
                  gériez un food truck de pizzas, vous avez certainement autre
                  chose à faire que de décrocher le téléphone à tout bout de
                  champ. Pourtant, rien ne devrait vous empêcher d&apos;accorder
                  toute l&apos;attention qu&apos;ils méritent à vos clients.
                  C&apos;est là qu&apos;intervient notre solution : un service
                  de callbot. Fini les interruptions incessantes pendant que
                  vous êtes au milieu d&apos;une coupe de cheveux, d&apos;une
                  réparation automobile ou de la préparation de votre prochaine
                  fournée de baguettes croustillantes. Avec notre service de
                  callbot, les appels sont gérés de manière efficace et
                  professionnelle.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
        ></Features191>
      </div>
      <div className="home-features4">
        <Features19
          feature1Title={
            <Fragment>
              <span className="home-text39">
                <span>SAV, FAQ, assistance technique</span>
                <br></br>
              </span>
            </Fragment>
          }
          feature1Slogan={
            <Fragment>
              <span className="home-text42">
                <span>GRANDS GROUPES</span>
                <br></br>
              </span>
            </Fragment>
          }
          feature1Action2={
            <Fragment>
              <span className="home-text45">Commencer</span>
            </Fragment>
          }
          feature1Description={
            <Fragment>
              <span className="home-text46">
                <span>
                  BTP, Opérateurs, Banques, ou autre services. Engrangez de la
                  satisfaction client au bout du fil. Un expérience SAV réussie
                  ne tient qu&apos;à peu de choses, rendez-vous disponibles,
                  compréhensif et empathiques envers vos clients en adoptant
                  Better call AI. Fournissez une assistance en ligne de qualité
                  et ouvrez votre base de connaissance par voie téléphonique.
                  Vos utilisateurs vous le rendront bien.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
        ></Features19>
      </div>
      <div id="Pricing" className="home-pricing">
        <Pricing14
          plan1={
            <Fragment>
              <span className="home-text49">Plan Startup</span>
            </Fragment>
          }
          plan2={
            <Fragment>
              <span className="home-text50">Plan Entreprise</span>
            </Fragment>
          }
          heading={
            <Fragment>
              <span className="home-text51">
                <span>Passez dans le futur,</span>
                <br></br>
                <span>Sans exploser votre budget</span>
              </span>
            </Fragment>
          }
          content2={
            <Fragment>
              <span className="home-text55">
                <span>
                  Si votre business n&apos;entre pas dans les cases, contactez
                  notre équipe commerciale, nous serions ravis d&apos;entendre
                  parler de votre situation
                </span>
                <span> </span>
              </span>
            </Fragment>
          }
          plan1Price={
            <Fragment>
              <span className="home-text58">50€ </span>
            </Fragment>
          }
          plan2Price={
            <Fragment>
              <span className="home-text59">200€</span>
            </Fragment>
          }
          plan1Action={
            <Fragment>
              <span className="home-text60">Commencer</span>
            </Fragment>
          }
          plan1Yearly={
            <Fragment>
              <span className="home-text61">par mois + consommation</span>
            </Fragment>
          }
          plan2Action={
            <Fragment>
              <span className="home-text62">Commencer</span>
            </Fragment>
          }
          plan2Yearly={
            <Fragment>
              <span className="home-text63">par mois + consommation</span>
            </Fragment>
          }
          plan1Feature1={
            <Fragment>
              <span className="home-text64">
                Personnalisation du télésecrétaire
              </span>
            </Fragment>
          }
          plan1Feature2={
            <Fragment>
              <span className="home-text65">Agenda Better Call AI</span>
            </Fragment>
          }
          plan1Feature3={
            <Fragment>
              <span className="home-text66">
                Jusqu&apos;à 4 appels simultanés
              </span>
            </Fragment>
          }
          plan2Feature1={
            <Fragment>
              <span className="home-text67">
                Personnalisation du télésecrétaire
              </span>
            </Fragment>
          }
          plan2Feature2={
            <Fragment>
              <span className="home-text68">Agenda Better Call AI</span>
            </Fragment>
          }
          plan2Feature3={
            <Fragment>
              <span className="home-text69">Appels simultanés illimités</span>
            </Fragment>
          }
          plan2Feature4={
            <Fragment>
              <span className="home-text70">Redirection vers un humain</span>
            </Fragment>
          }
          plan1Feature33={
            <Fragment>
              <span className="home-text71">Redirection vers un humain</span>
            </Fragment>
          }
          plan2Feature42={
            <Fragment>
              <span className="home-text72">Tarif d&apos;un appel 0.10€</span>
            </Fragment>
          }
          plan2Feature43={
            <Fragment>
              <span className="home-text73">
                Pas de limite d&apos;appels par jour 
              </span>
            </Fragment>
          }
          plan1Feature331={
            <Fragment>
              <span className="home-text74">Tarif d&apos;un appel 0.15€</span>
            </Fragment>
          }
          plan1Feature332={
            <Fragment>
              <span className="home-text75">Limite de 20 appels par jour </span>
            </Fragment>
          }
          plan2Feature421={
            <Fragment>
              <span className="home-text76">Accompagnement sur-mesure</span>
            </Fragment>
          }
          plan2Feature422={
            <Fragment>
              <span className="home-text77">Accès la plateforme admin</span>
            </Fragment>
          }
        ></Pricing14>
      </div>
      <FooterGray rootClassName="footer-grayroot-class-name"></FooterGray>
    </div>
  )
}

export default Home
